module.exports = __webpack_public_path__ + "static/media/factionfinancialwhite.b2f0aa50.png";